import React, { useEffect, useRef, useState } from 'react';

import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const FactorFlash = () => {
  const [target, setTarget] = useState(null);
  const [input, setInput] = useState('');
  const [foundFactors, setFoundFactors] = useState([]);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [score, setScore] = useState(0);

  const correctSound = useRef(null);
  const wrongSound = useRef(null);

  const generateNewNumber = () => {
    const random = Math.floor(Math.random() * 41) + 10;
    setTarget(random);
    setFoundFactors([]);
    setScore(0);
    setFeedback('');
    setFeedbackColor('');
    setInput('');
  };

  const handleSubmit = () => {
    const guess = parseInt(input);
    if (!guess || guess <= 0) return;

    if (target % guess === 0) {
      if (!foundFactors.includes(guess)) {
        const updatedFactors = [...foundFactors, guess];
        setFoundFactors(updatedFactors);
        setFeedback('✅ Nice!');
        setFeedbackColor('green');
        setScore(score + 10);
        correctSound.current.play();

        // Check if all factors are found
        const allFactors = [];
        for (let i = 1; i <= target; i++) {
          if (target % i === 0) allFactors.push(i);
        }

        if (updatedFactors.length === allFactors.length) {
          setTimeout(() => {
            setFeedback('🎯 All factors found! Moving on...');
            setFeedbackColor('#4caf50');
          }, 400);

          const responsedata = ConstructorEventUpdateSQLStatus();
          console.log("Event completed", responsedata);

          setTimeout(() => {
            generateNewNumber();
          }, 1200); // Short delay to show the final message before next question
        }
      } else {
        setFeedback('❗Already used!');
        setFeedbackColor('#ff9800');
      }
    } else {
      setFeedback('❌ Not a factor!');
      setFeedbackColor('red');
      setScore(score - 5);
      wrongSound.current.play();
    }

    setInput('');
  };

  useEffect(() => {
    generateNewNumber();
  }, []);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(to bottom right, #fceabb, #f8b500)',
      margin: 0,
      padding: 0,
      textAlign: 'center',
      overflow: 'hidden',
      minHeight: '100vh',
    },
    container: {
      backgroundColor: '#fff3e0',
      margin: '30px auto',
      padding: '30px',
      width: '90%',
      maxWidth: '600px',
      borderRadius: '20px',
      boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
    },
    h1: {
      marginTop: '20px',
      fontSize: '3rem',
      color: '#3e2723',
    },
    target: {
      fontSize: '4rem',
      margin: '20px 0',
      color: '#ff6f00',
    },
    input: {
      fontSize: '1.2rem',
      padding: '10px',
      margin: '0.5rem',
      borderRadius: '10px',
      border: '2px solid #ff69b4',
      width: '100px',
      textAlign: 'center',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    button: {
      padding: '15px 20px',
      fontSize: '1.5rem',
      backgroundColor: '#66bb6a',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
    },
    buttonHover: {
      backgroundColor: '#388e3c',
    },
    feedback: {
      fontSize: '1.5rem',
      marginTop: '15px',
      height: '30px',
      color: feedbackColor,
    },
    score: {
      fontSize: '1.2rem',
      marginTop: '15px',
    },
    factor: {
      display: 'inline-block',
      margin: '5px',
      padding: '10px 15px',
      backgroundColor: '#ffee58',
      borderRadius: '10px',
      fontWeight: 'bold',
    },
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>⭐ Factor Flash ⭐</h1>
      <div style={styles.container}>
        <div style={styles.target}>{target}</div>
        <input
          type="number"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          style={styles.input}
          placeholder="Factor"
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
        />
        <button style={styles.button} onClick={handleSubmit}>Submit</button>
        <div style={styles.feedback}>{feedback}</div>
        <div style={{ marginTop: '20px', fontSize: '1.2rem' }}>
          {foundFactors.map((factor, i) => (
            <span key={i} style={styles.factor}>{factor}</span>
          ))}
        </div>
        <div style={styles.score}>Score: {score}</div>
      </div>

      <audio ref={correctSound} src="https://cdn.pixabay.com/audio/2022/03/15/audio_c715d21449.mp3" />
      <audio ref={wrongSound} src="https://cdn.pixabay.com/audio/2022/03/15/audio_e2cb9f23b5.mp3" />
    </div>
  );
};

export default FactorFlash;
